import { GIT_REV } from "../buildenv";

export const ENV = {
  GIT_REV,
};
